export interface IConditionalRenderProps {
    children?: React.ReactNode
    condition?: boolean
}
export const ConditionalRender = ({ children, condition }: IConditionalRenderProps) => {
    return condition ? <>{children}</> : <></>
}

export default ConditionalRender
